module.exports = __webpack_public_path__ + "img/404.94f6e3ea.jpg";